import { EventrDate, setUserPref } from '@eventr/common'
import {
    ColoursObj,
    getFlagEmojiFromTimezoneEnum,
    Icon,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { useMemo } from 'react'
import i18n from '../../../../../i18n/i18next'
import { bs } from '../../../../../state/bound.store'
import { defaultAddSnack } from '../../../../../state/overlayState/overlayContext'
import { userPrefShowDestTime } from '../../../../../state/userPrefsState/userPrefsSignels'

/**
 * Toggle for zone of itin or user local zone
 */
export default function CarouselZoneToggle() {
    const localTzEventrDate = new EventrDate()

    const getCurrentBool = useMemo(() => {
        const current = userPrefShowDestTime.value
        if (current) {
            if (current === 'itinLocal') {
                return true
            } else if (current === 'userLocal') {
                return false
            }
        } else {
            return false
        }
    }, [userPrefShowDestTime.value])

    /// For now using a switch but might change to a 3way toggle or something if adding utc
    return (
        <Box display={'grid'} gridAutoFlow={'column'} alignItems={'center'}>
            <Typography fontSize={'24px'}>
                {!getCurrentBool &&
                    getFlagEmojiFromTimezoneEnum(
                        localTzEventrDate.timezoneNumber ?? 0
                    )}
            </Typography>
            <Icon
                name="Time"
                iconColour={ColoursObj.shades.shade5}
                onClick={() => {
                    if (!getCurrentBool) {
                        setUserPref('itinerary', 'showDestTime', 'itinLocal')
                        userPrefShowDestTime.value = 'itinLocal'
                        bs().setCurrentItin(bs().selectedItinID)
                        defaultAddSnack(
                            i18n.t('snack.timezoneToggleEvent'),
                            'info'
                        )
                    } else {
                        setUserPref('itinerary', 'showDestTime', 'userLocal')
                        userPrefShowDestTime.value = 'userLocal'
                        bs().setCurrentItin(bs().selectedItinID)
                        defaultAddSnack(
                            i18n.t('snack.timezoneToggleUser'),
                            'info'
                        )
                    }
                }}
            />
        </Box>
    )
}
